import {useMediaQuery} from '@mui/material'
import moment from 'moment/moment'
import React, {ReactElement, useRef} from 'react'
import {SliderControlButtons, RegisterButton} from 'features/buttons'
import {CreditCard, Headset, Verified} from 'shared/ui/icons'
import {UserCardPreview} from 'widgets/userCardPreview'
import areerat from './img/areerat.webp'
import artem from './img/artem.webp'
import elsie from './img/elsie.webp'
import ivan from './img/ivan.webp'
import jenny from './img/jennyNicole.jpeg'
import karine from './img/karine.webp'
import laura from './img/laura.webp'
import olga from './img/olga.webp'
import styles from './styles.module.scss'

const cardWidth = 256

const usersList = [
  {
    name: 'Karine',
    age: moment().diff('April 28, 1975', 'year'),
    images: [karine],
    description: `don't be shy! take the first step, Mr`,
    isHot: true,
    isOnline: true,
    isVerified: true,
  },
  {
    name: 'Elsie',
    age: moment().diff('April 28, 1997', 'year'),
    images: [elsie],
    description: 'Communication is established! You feel?)',
    isOnline: true,
    isHot: true,
  },
  {
    name: 'Areerat',
    age: moment().diff('April 28, 1998', 'year'),
    images: [areerat],
    description: `why are you looking at me but still not writing?`,
    isOnline: true,
    isVerified: true,
  },
  {
    name: 'Olga',
    age: moment().diff('April 28, 1982', 'year'),
    images: [olga],
    description: `truth or dare? ;) your move, stranger 😏`,
    isOnline: true,
    isHot: true,
  },
  {
    name: 'Jenny-Nicole',
    age: moment().diff('April 28, 1990', 'year'),
    images: [jenny],
    description: `IT’S TIME TO GET TO KNOW! Ready?) `,
    isHot: true,
    isOnline: true,
    isVerified: true,
  },
  {
    name: 'Artem',
    age: moment().diff('April 28, 1989', 'year'),
    images: [artem],
    description: `why are you looking at me but still not writing?)`,
    isOnline: true,
    isHot: true,
  },
  {
    name: 'Laura Susana',
    age: moment().diff('April 28, 1995', 'year'),
    images: [laura],
    description: `Are you willing to steal my heart?`,
    isOnline: true,
    isHot: true,
  },
  {
    name: 'Ivan',
    age: moment().diff('April 28, 1992', 'year'),
    images: [ivan],
    description: `Maybe I’m the one who will change your life?`,
    isOnline: true,
    isVerified: true,
  },
]

export const GirlPreviewSection: React.FC = () => {
  const ref = useRef(null)
  const isTablet = useMediaQuery(`(max-width: 1220px)`)
  const isMobile = useMediaQuery(`(max-width: 909px)`)

  return (
    <div>
      <div className={styles.container}>
        <div className={`${styles.cardWrapper} overflowX`} ref={ref}>
          {usersList.map((item, index) => (
            <UserCardPreview
              key={index}
              sliderClassName={styles.slider}
              className={styles.cardMini}
              {...item}
            />
          ))}
        </div>
        {
          isMobile ? <div className={styles.controls}>
            <SliderControlButtons ref={ref} step={cardWidth} count={isTablet ? 6 : 8} />
            <RegisterButton className={styles.btn} styleType='primary'>Show more</RegisterButton>
          </div> : null
        }
      </div>
      <div className={styles.advantageContainer}>
        <div className={styles.privilegeWrapper}>
          <AdvantageComponent
            icon={<Verified />}
            title='Verified'
            description='100% manually verified profiles and secure communication'
          />
          <AdvantageComponent
            icon={<CreditCard />}
            title='No card'
            description='No card - join and start surfing free now'
          />
          <AdvantageComponent
            icon={<Headset />}
            title='Premium support'
            description='Dedicated team creates great experience'
          />
        </div>
      </div>
    </div>
  )
}

type AdvantageComponentProps = {
  icon: ReactElement
  title: string,
  description: string
}

const AdvantageComponent: React.FC<AdvantageComponentProps> = ({icon, title, description}) => {
  return (
    <div className={styles.privilege}>
      <div className={styles.privilege__icon}>{icon}</div>
      <p className={styles.privilege__title}>{title}</p>
      <p className={styles.privilege__description}>{description}</p>
    </div>
  )
}